module.exports = __webpack_public_path__ + "img/checking.3321603d.png";